import * as actionTypes from './actionTypes';
import axios from 'axios';
import { formatCurrency } from '../../shared/utility';

export const addProductStart = (  ) => {
    return {
        type: actionTypes.ADD_PRODUCT_START,
    }
}
export const addProductSuccess = ( addedProductDetails, quantity ) => {
    return {
        type: actionTypes.ADD_PRODUCT_SUCCESS,
        addedProduct: addedProductDetails,
        addedQuantity: quantity,
    }
}
export const addProductFailed = ( errorMessage ) => {
    return {
        type: actionTypes.ADD_PRODUCT_FAILED,
        error: errorMessage,
    }
}
export const addProductToCart = ( product , quantity = 1 ) => {
    return dispatch => {
        dispatch( addProductStart( ) )
        axios.post('https://color-shop-c3776-default-rtdb.firebaseio.com/cart/items.json', product )
            .then( response => {
                    const addedProduct = { orderId: response.data.name, ...product  }
                    console.log(quantity);
                    dispatch( addProductSuccess( addedProduct, quantity ) );
                })
            .catch( err => {
                dispatch( addProductFailed( err ) )
            } )
    }
}

export const increaseProductStart = (  ) => {
    return {
        type: actionTypes.INCREASE_PRODUCT_START,
    }
}
export const increaseProductSuccess= ( id , quantity , quantityAdded ) => {
    return {
        type: actionTypes.INCREASE_PRODUCT_SUCCESS,
        productId: id,
        productQuantity: quantity,
        quantityAdded: quantityAdded
    }
}
export const increaseProductFailed = ( err ) => {
    return {
        type: actionTypes.INCREASE_PRODUCT_FAILED,
        increaseError: err
    }
}

export const increaseProduct = ( id , quantity, quantityAdded ) => {
    return dispatch => {
        dispatch( increaseProductStart( ) )
        axios.patch(`https://color-shop-c3776-default-rtdb.firebaseio.com/cart/items/${id}.json` , { quantity: quantity } )
                .then( res => {
                    dispatch( increaseProductSuccess( id, res.data.quantity, quantityAdded ) )
                } )
                .catch( err => {
                    dispatch( increaseProductFailed( err ) )
                } )
    }
}

export const removeProductStart = (  ) => {
    return {
        type: actionTypes.REMOVE_PRODUCT_START,
    }
}
export const removeProductSuccess = ( id ) => {
    return {
        type: actionTypes.REMOVE_PRODUCT_SUCCESS,
        removedProductId : id,
    }
}
export const removeProductFailed = ( errorMessage ) => {
    return {
        type: actionTypes.REMOVE_PRODUCT_FAILED,
        removeError: errorMessage,
    }
}

export const removeProductFromCart = ( id  ) => {
    return dispatch => {
        dispatch( removeProductStart( ) )
        axios.delete(`https://color-shop-c3776-default-rtdb.firebaseio.com/cart/items/${id}.json`)
            .then( response => dispatch( removeProductSuccess( id ) ) )
            .catch( err => dispatch( removeProductFailed( err.message ) ) )
    }
}


export const fetchCartStart = (  ) => {
    return {
        type: actionTypes.FETCH_CART_START,
    }
}
export const fetchCartSuccess = ( productsData , itemsQuantity) => {
    return {
        type: actionTypes.FETCH_CART_SUCCESS,
        cartProducts: productsData,
        cartQuantity: itemsQuantity,
    }
}
export const fetchCartFailed = ( errorMessage ) => {
    return {
        type: actionTypes.FETCH_CART_FAILED,
        error: errorMessage,
    }
}
export const fetchCart = (  ) => {
    return dispatch => {
        dispatch( fetchCartStart( ) );
        axios.get('https://color-shop-c3776-default-rtdb.firebaseio.com/cart/items.json')
                .then( response => {
                    let cartProducts = [ ];
                    for ( let color in response.data ) {
                        let dollars =  formatCurrency( ( response.data[color].priceCents * response.data[color].quantity ) / 100) ;
                        let fetchedProducts = { orderId: color ,  ...response.data[color] , price: dollars }
                        cartProducts.push(fetchedProducts);
                    }
                    let cartQuantity =cartProducts.map( item =>item.quantity )
                                                                    .reduce( ( arr , el ) => arr + el , 0)
                    dispatch( fetchCartSuccess( cartProducts , cartQuantity ) );
                })
                .catch( err => {
                    dispatch( fetchCartFailed( err.message  ) );
                } )
            }
}
export const deleteCartStart = (  ) => {
    return {
        type: actionTypes.DELETE_CART_START,
    }
}
export const deleteCartSuccess = ( ) => {
    return {
        type: actionTypes.DELETE_CART_SUCCESS,
    }
}
export const deleteCartFailed = ( errorMessage ) => {
    return {
        type: actionTypes.FETCH_CART_FAILED,
        error: errorMessage,
    }
}
export const deleteCart = (  ) => {
    return dispatch => {
        dispatch( deleteCartStart( ) )
        axios.delete('https://color-shop-c3776-default-rtdb.firebaseio.com/cart.json')
            .then( response => {
                dispatch( deleteCartSuccess( ) );
            })
            .catch( err => {
                dispatch( deleteCartFailed( err.message  ) );
            } )
        }
}
